import React from 'react';
import PropTypes from 'prop-types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import Notification from 'components/notifications/Notification';
import LoginBackground from 'components/layout/Layout/LoginBackground';
import SignUpForm from './SignUpForm';
import { connect } from 'react-redux';
import { showNotification } from 'store/actions/uiActions';

const SignUpContainer = (props) => {

    const onSubmit = (values) => {
        const url = `${ config.getApiBaseUrl() }/auth/register`;
        const { showNotificationMessage, history } = props;

        apiClient.create(url, values).then(() => {
            showNotificationMessage('signUp.success', 'success');
            history.push('/login');
        }).catch((err) => {
            showNotificationMessage(err.response.message, 'warning');
        });
    };

    const onCancel = () => {
        props.history.push('/login');
    };

    return (
        <div>
            <LoginBackground />

            <SignUpForm
                form='sign-up'
                handleSubmitForm={ onSubmit }
                handleCancelForm={ onCancel }
            />

            <Notification />
        </div>
    );
};

SignUpContainer.propTypes = {
    history: PropTypes.object.isRequired,
    showNotificationMessage: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        showNotificationMessage: (msg, type) => {
            dispatch(showNotification(msg, type));
        },
    };
};

export default connect(null, mapDispatchToProps)(SignUpContainer);


// WEBPACK FOOTER //
// ./src/pages/signUp/SignUpContainer.js